import React,{ useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './common/Header';
import Meow from './common/Meow'; 
import Nav from './common/Navigation';

export default function Explore({titleHead}){
	let navigate = useNavigate();
	
	useEffect(() => {
		let authToken = sessionStorage.getItem("Auth Token");
		
		if(authToken){
			navigate('/explore')
		}
		
		if(!authToken){
			navigate('/')
		}
	}, [])
	
	return(
		<>
			<Header titleHead={titleHead}/>
			<Meow />
			<main>
				<h2>{titleHead}ing and wandering here and there is fun</h2>
				<h4>Welcome to the tribe my buddy</h4>
			</main>
			<Nav />
		</>
	);
}